module.exports = __webpack_public_path__ + "img/stock5.b7114fd4.png";